import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=dd959544&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
import style0 from "./Payments.vue?vue&type=style&index=0&id=dd959544&prod&lang=scss"
import style1 from "./Payments.vue?vue&type=style&index=1&id=dd959544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd959544",
  null
  
)

export default component.exports